import {Loader} from '../components/loader';
import React, {useEffect, useRef, useState} from 'react';
import {Animated, Easing} from 'react-native';
import {useStyles} from '../hooks/styles';
import {hexToRgbA} from '../pipes';
import {Text} from 'react-native';

export interface IModel {
  blockingCallCount: number;
  loaderText?: string;
  showLoader?: boolean;
}

export default (props: IModel) => {
  const {blockingCallCount, loaderText, showLoader} = props;
  const [hideLoader, setHideLoader] = useState(true);
  const showAnim = useRef(new Animated.Value(0)).current;

  Animated.timing(showAnim, {
    toValue: 1,
    useNativeDriver: true,
    duration: 500,
    easing: Easing.linear,
  }).start();

  const styles = useStyles(({theme}) => ({
    loader: {
      position: 'absolute',
      top: 0,
      paddingTop: 180,
      left: 0,
      right: 0,
      bottom: 0,
      alignItems: 'center',
      zIndex: 1000,
      backgroundColor: hexToRgbA(theme.color.loaderBgColor, 0.5),
    },
    text: {
      fontSize: 20,
    },
  }));

  useEffect(() => {
    const shouldShow = blockingCallCount > 0 || !!showLoader;
    if (!shouldShow && !hideLoader) {
      setHideLoader(true);
      Animated.timing(showAnim, {
        toValue: 0,
        useNativeDriver: true,
        duration: 500,
        easing: Easing.linear,
      }).start(() => {
        setHideLoader(true);
      });
    } else if (shouldShow && hideLoader) {
      setHideLoader(false);
      Animated.timing(showAnim, {
        toValue: 1,
        useNativeDriver: true,
        duration: 500,
        easing: Easing.linear,
      }).start();
    }
  }, [blockingCallCount, showLoader]);

  if (hideLoader) {
    return null;
  }
  const dataViewAttrs = {
    dataSet: {
      class: 'loader',
    },
  };
  return (
    <Animated.View style={[styles.loader, {opacity: showLoader ? 100 : showAnim}]} {...dataViewAttrs}>
      <Text style={styles.text}>{loaderText}</Text>
      <Loader size={130} />
    </Animated.View>
  );
};
